import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { addDaysToLADateKey, formatLADateRangeArrow } from '../../utils/laDateUtils';

/**
 * Post-submit failure summary for ParticipantBookingPanel's create-mode flow.
 * Every night usually fails for the same reason (e.g. a duplicate booking
 * spans the whole range) — collapse that into one clear sentence instead
 * of repeating the same message once per date.
 */
const BookingFailureBanner = ({ failedNights, nights, bookedNightsSoFar }) => {
  if (!failedNights.length) return null;

  const allSameReason = failedNights.every((f) => f.message === failedNights[0].message);
  const isDuplicate = allSameReason && /already booked in this room/i.test(failedNights[0].message);
  const failedDateKeysSorted = [...failedNights.map((f) => f.dateKey)].sort();
  const failedRangeLabel = formatLADateRangeArrow(
    failedDateKeysSorted[0],
    addDaysToLADateKey(failedDateKeysSorted[failedDateKeysSorted.length - 1], 1)
  );

  return (
    <div className="pbt-panel__error-banner">
      <AlertTriangle size={14} />
      {isDuplicate ? (
        <span>
          This participant already has a booking in this room for {failedRangeLabel}. Close this panel and use <strong>Edit</strong> on that booking to make changes instead of creating a new one.
        </span>
      ) : allSameReason ? (
        <span>
          Couldn't book {failedRangeLabel}: {failedNights[0].message}
        </span>
      ) : (
        <span>
          Booked {bookedNightsSoFar} of {nights} night{nights !== 1 ? 's' : ''}. Failed: {failedNights.map((f) => `${f.dateKey} (${f.message})`).join('; ')}
        </span>
      )}
    </div>
  );
};

export default BookingFailureBanner;
